<div mat-dialog-title class="modal-title">
  <mat-icon>post_add</mat-icon>
  <span>{{ editMode ? 'Editar clase' : 'Nueva clase' }}</span>
  <mat-icon class="close-button" (click)="confirmCloseModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  @if (isLoadingClass) {
    <div class="loading-page">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  } @else {
    <div class="thumbnail" (click)="classThumbnail.click()">
      @if (!currentThumbnail && !imageToUploadSrc) {
        <div class="hint">
          <mat-icon> add_photo_alternate </mat-icon>
          <span> Imagen 16 : 9 </span>
        </div>
      }
      @if (currentThumbnail && !imageToUploadSrc) {
        <img [src]="currentThumbnail" />
      }
      @if (imageToUploadSrc) {
        <img [src]="imageToUploadSrc" />
      }
      <input
        #classThumbnail
        type="file"
        name="classThumbnail"
        id="classThumbnail"
        class="classThumbnail"
        accept=".jpg, .png"
        (change)="onSelectImage($event)"
      />
    </div>
    <form [formGroup]="classForm" class="row">
      <div class="col-12">
        <div class="form-control hidden">
          <mat-slide-toggle color="primary" formControlName="hidden"> ¿Ocultar clase? </mat-slide-toggle>
        </div>
      </div>
      <div class="col-12">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Nombre de la clase</mat-label>
            <input matInput type="text" placeholder="Nombre de la clase" formControlName="name" name="className" autocomplete="off" />
            <mat-error> Nombre de la clase requerido </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12 hint">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>URL de Vimeo</mat-label>
            <input matInput type="text" formControlName="videoUrl" name="videoUrl" autocomplete="off" />
            <mat-error> URL de Vimeo requerida </mat-error>
            <mat-hint>
              {{ 'https://player.vimeo.com/video/\{id_video\}' }}
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Descripción de la clase</mat-label>
            <textarea
              matInput
              rows="5"
              placeholder="Descripción de la clase"
              formControlName="description"
              name="description"
              autocomplete="off"
            ></textarea>
            <mat-error> Descripción de la clase requerida </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12 hint">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>¿A qué categorías pertenece esta clase?</mat-label>
            <mat-select placeholder="Selecciona una o varias" formControlName="categories" name="categories" autocomplete="off" multiple>
              @for (category of categories; track category.membersCategoryId; let i = $index) {
                <mat-option [value]="category.membersCategoryId">
                  {{ category.name }}
                </mat-option>
              }
            </mat-select>
            <mat-hint> Puedes seleccionar una o varias </mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12 hint">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>¿A qué niveles pertenece esta clase?</mat-label>
            <mat-select placeholder="Selecciona uno o varias" formControlName="levels" name="levels" autocomplete="off" multiple>
              @for (level of levels; track level.membersLevelId; let i = $index) {
                <mat-option [value]="level.membersLevelId">
                  {{ level.name }}
                </mat-option>
              }
            </mat-select>
            <mat-hint> Puedes seleccionar uno o varias </mat-hint>
          </mat-form-field>
        </div>
      </div>
      @if (classForm.value.categories.length) {
        <div class="col-12">
          <div class="form-control">
            <div class="positions" formArrayName="positions">
              <div class="positions-header"> Selecciona la posición de la clase para cada categoría </div>
              @for (position of positionsControls(); track position; let i = $index) {
                <div [formGroupName]="i" class="position">
                  <div class="position-item">
                    <div class="position-category"> <b>Categoría:</b> {{ getCategoryName(position.value.categoryId) }} </div>
                    <div class="position-content">
                      <mat-form-field color="primary" appearance="outline">
                        <mat-label>¿En qué posición quieres que aparezca?</mat-label>
                        <mat-select placeholder="Selecciona una" formControlName="position" name="position" autocomplete="off">
                          @if (!getCategoryClasses(position.value.categoryId).length) {
                            <mat-option [value]="0"> Al principio </mat-option>
                          }
                          @for (categoryClass of getCategoryClasses(position.value.categoryId); track categoryClass.membersClassId; let j = $index) {
                            <mat-option [value]="j"> Posición {{ j + 1 }}: En vez de "{{ categoryClass.name }}" </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <div class="col-12">
        <div class="upload-files">
          <span>Sube recursos para esta clase</span>
          <enfaf-dropzone
            [acceptMultiple]="true"
            [acceptLimit]="10"
            [acceptBigFiles]="true"
            filesToAccept="*"
            (filesDropped)="onDroppedAttachments($event)"
          >
          </enfaf-dropzone>
        </div>
      </div>
      @if (currentAttachments.length) {
        <div class="col-12 remote-attachments">
          <enfaf-remote-attachments
            [remoteAttachments]="currentAttachments"
            title="Recursos existentes de esta clase"
            [isDeletingRemoteAttachment]="isDeletingRemoteAttachment"
            (onDeleteRemoteAttachment)="onDeleteRemoteAttachment($event)"
          >
          </enfaf-remote-attachments>
        </div>
      }
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="confirmCloseModal()"> Cerrar </button>
  <button
    mat-flat-button
    color="primary"
    (click)="saveClass()"
    [disabled]="classForm.invalid || isSavingClass || (!imageToUpload && !currentThumbnail)"
  >
    @if (!isSavingClass) {
      <span>Guardar</span>
    } @else {
      <mat-spinner class="white-spinner"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
